import React, { useRef } from 'react';
import { Star } from 'lucide-react';
import { Card } from './ui/Card';
const testimonials = [{
  quote: 'Absolutely incredible results on our driveway. Looks brand new. Booked again for spring.',
  name: 'Michael R.',
  location: 'Oakridge Estates'
}, {
  quote: 'Fast, professional, and fair pricing. Pressure Perfect is the only call I make.',
  name: 'Sarah T.',
  location: 'Pine Valley'
}, {
  quote: 'Our house siding went from green with algae to spotless white. Highly recommend.',
  name: 'David L.',
  location: 'Westside'
}];
export function Testimonials() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  return <section className="py-20 md:py-32 bg-white overflow-hidden" data-id="element-167">
      <div className="container mx-auto px-4 md:px-6" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-primary mb-4 uppercase" data-id="element-170">
            What Our Customers Are Saying
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto" data-id="element-171" />
        </div>

        {/* Mobile Swipeable / Desktop Grid */}
        <div ref={scrollContainerRef} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-8 -mx-4 px-4 md:mx-0 md:px-0 md:grid md:grid-cols-3 gap-6 md:overflow-visible" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-172">
          {testimonials.map((testimonial, index) => <Card key={index} className="min-w-[85vw] sm:min-w-[300px] md:min-w-0 snap-center p-8 border border-border shadow-lg hover:shadow-xl transition-shadow bg-white flex flex-col" data-id="element-173">
              <div className="flex gap-1 mb-6" data-id="element-174">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-accent text-accent" data-id="element-175" />)}
              </div>
              <p className="text-lg md:text-xl text-primary font-medium mb-8 flex-grow italic" data-id="element-176">
                "{testimonial.quote}"
              </p>
              <div data-id="element-177">
                <p className="font-bold text-primary text-lg" data-id="element-178">
                  {testimonial.name}
                </p>
                <p className="text-muted-foreground" data-id="element-179">{testimonial.location}</p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}